<template>
  <div class="customer-info-container" :style="{paddingBottom: hasBottomPadding ? '84px' : 0}">
    <Loading v-if="loading"></Loading>
    <div class="info-container">
      <h2 class="title">基本信息</h2>
      <van-cell-group>
        <van-field v-model="formValue.name" :readonly="baseConfirmed" required clearable label="真实姓名" placeholder="请填写真实姓名" :maxlength="4" />
        <van-field v-model="formValue.phoneNo" :readonly="baseConfirmed" required clearable label="手机号码" placeholder="请填写手机号码" :maxlength="11" />
        <van-field v-model="formValue.certId" :readonly="baseConfirmed" required clearable label="身份证号" placeholder="请填写身份证号" :maxlength="18" />
        <van-field v-model="formValue.bookingCode" :readonly="baseConfirmed" required clearable label="短信验证码" placeholder="请填写短信验证码" :maxlength="6" class="code-field">
          <template #button>
            <van-button style="width: 110px;" size="small" type="primary" @click="onSendCode" :disabled="counting">
              {{counting ? `重新发送(${countDown}s)` : '发送验证码'}}
            </van-button>
          </template>
        </van-field>
      </van-cell-group>
    </div>
    <div class="info-container" v-if="baseConfirmed">
      <h2 class="title">工作信息</h2>
      <van-cell-group>
        <van-field
          readonly
          required
          clickable
          name="area"
          :value="formValue.workCity"
          label="工作所在城市"
          placeholder="请选择工作所在城市"
          @click="showWorkCity = !readonly"
        />
        <van-field name="radio" label="雇佣类型" required>
          <template #input>
            <van-radio-group v-model="formValue.employType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">受薪</van-radio>
              <van-radio name="1">私营</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="工作单位性质" required v-if="isEmployee">
          <template #input>
            <van-radio-group v-model="formValue.workCompanyType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">国企</van-radio>
              <van-radio name="1">事业单位</van-radio>
              <van-radio name="2">500强</van-radio>
              <van-radio name="3">普通企业</van-radio>
              <van-radio name="4">自由职业</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="发薪方式" required v-if="isEmployee">
          <template #input>
            <van-radio-group v-model="formValue.salaryType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">打卡</van-radio>
              <van-radio name="1">现金</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="isEmployee"
          readonly
          clickable
          name="picker"
          :value="formValue.salaryDate"
          label="每月发薪日"
          placeholder="请选择每月发薪日"
          @click="showSalaryDatePicker = !readonly"
        />
        <van-field
          v-if="isEmployer"
          readonly
          clickable
          required
          name="calendar"
          :value="formValue.companyEstablishTime"
          label="公司成立时间"
          placeholder="请选择公司成立时间"
          @click="showCompanyCalendar = !readonly"
        />
        <van-field
          v-if="isEmployer"
          v-model="formValue.annualTurnover"
          type="digit"
          clearable
          :readonly="readonly"
          label="年营业额"
          placeholder="请填写年营业额"
        >
          <span slot="right-icon">万元</span>
        </van-field>
        <van-field
          v-if="isEmployer"
          v-model="formValue.annualInvoiceAmount"
          type="digit"
          clearable
          :readonly="readonly"
          label="年开票额"
          placeholder="请填写年开票额"
        >
          <span slot="right-icon">万元</span>
        </van-field>
        <van-field
          v-if="isEmployer"
          v-model="formValue.annualTaxAmount"
          type="digit"
          clearable
          :readonly="readonly"
          label="年纳税额"
          placeholder="请填写年纳税额"
        >
          <span slot="right-icon">万元</span>
        </van-field>
        <van-field
          v-if="isEmployer"
          v-model="formValue.equityRatio"
          type="number"
          clearable
          :readonly="readonly"
          label="股权占比"
          placeholder="请填写股权占比(%)"
        >
          <span slot="right-icon">%</span>
        </van-field>
        <van-field v-if="isEmployer" name="radio" label="私营企业类型" required>
          <template #input>
            <van-radio-group v-model="formValue.companyType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">个体</van-radio>
              <van-radio name="1">私营</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>
    </div>
    <div class="info-container" v-if="baseConfirmed">
      <h2 class="title">收入信息</h2>
      <van-cell-group>
        <van-field
          v-model="formValue.salaryAfterTax"
          type="digit"
          required
          clearable
          :readonly="readonly"
          label="税后月收入"
          placeholder="请填写税后月收入"
        />
        <van-field name="radio" label="社保/公积金" required>
          <template #input>
            <van-radio-group v-model="formValue.hasSecurityOrFunds" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="hasSecurityOrFunds"
          v-model="formValue.securityBase"
          type="number"
          clearable
          :readonly="readonly"
          label="社保月缴存额"
          placeholder="请填写社保月缴存额"
        />
        <van-field
          v-if="hasSecurityOrFunds"
          v-model="formValue.securityMonth"
          type="digit"
          clearable
          :readonly="readonly"
          label="社保连续缴存月数"
          placeholder="请填写社保连续缴存月数"
        />
        <van-field
          v-if="hasSecurityOrFunds"
          v-model="formValue.fundsBase"
          type="number"
          clearable
          :readonly="readonly"
          label="公积金月缴存额"
          placeholder="请填写公积金月缴存额"
        />
        <van-field
          v-if="hasSecurityOrFunds"
          v-model="formValue.fundsMonth"
          type="digit"
          clearable
          :readonly="readonly"
          label="公积金连续缴存月数"
          placeholder="请填写公积金连续缴存月数"
        />
        <van-field
          v-if="hasSecurityOrFunds"
          v-model="formValue.fundsBalance"
          type="number"
          clearable
          :readonly="readonly"
          label="公积金月余额"
          placeholder="请填写公积金月余额"
        />
      </van-cell-group>
    </div>
    <div class="info-container" v-if="baseConfirmed">
      <h2 class="title">负债信息</h2>
      <van-cell-group>
        <van-field name="radio" label="是否有负债" required>
          <template #input>
            <van-radio-group v-model="formValue.hasDebt" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="hasDebt"
          v-model="formValue.totalDebt"
          type="digit"
          required
          clearable
          :readonly="readonly"
          label="负债总金额"
          placeholder="请填写负债总金额"
        />
        <van-field
          v-if="hasDebt"
          v-model="formValue.monthDebtRepayments"
          type="digit"
          required
          clearable
          :readonly="readonly"
          label="负债月还款额"
          placeholder="请填写负债月还款额"
        />
      </van-cell-group>
    </div>
    <div class="info-container" v-if="baseConfirmed">
      <h2 class="title">资产信息</h2>
      <van-cell-group>
        <van-field name="radio" label="是否有物业" required>
          <template #input>
            <van-radio-group v-model="formValue.hasHouse" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="物业性质" required v-if="hasHouse">
          <template #input>
            <van-radio-group v-model="formValue.houseType" direction="horizontal" :disabled="readonly">
              <van-radio name="1">住宅</van-radio>
              <van-radio name="0">商铺</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="hasHouse"
          readonly
          required
          clickable
          name="area"
          :value="formValue.houseCity"
          label="房产所在城市"
          placeholder="请选择房产所在城市"
          @click="showHouseCity = !readonly"
        />
        <van-field v-if="hasHouse" name="radio" label="房产是否按揭" required>
          <template #input>
            <van-radio-group v-model="formValue.isHouseLoan" direction="horizontal" :disabled="readonly">
              <van-radio name="1">全款</van-radio>
              <van-radio name="0">按揭</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="isHouseLoan"
          v-model="formValue.houseLoanTotalMonth"
          type="number"
          required
          clearable
          :readonly="readonly"
          label="房贷期数"
          placeholder="请填写房贷期数"
        />
        <van-field
          v-if="isHouseLoan"
          v-model="formValue.houseLoanAlreadyMonth"
          type="number"
          required
          clearable
          :readonly="readonly"
          label="房贷已还期数"
          placeholder="请填写房贷已还期数"
        />
        <van-field
          v-if="isHouseLoan"
          v-model="formValue.houseMonthMortgage"
          type="number"
          required
          clearable
          :readonly="readonly"
          label="房贷月供"
          placeholder="请填写房贷月供"
        />
        <van-field name="radio" label="是否有私家车" required>
          <template #input>
            <van-radio-group v-model="formValue.hasCar" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasCar" name="radio" label="车辆是否按揭" required>
          <template #input>
            <van-radio-group v-model="formValue.isCarLoan" direction="horizontal" :disabled="readonly">
              <van-radio name="1">全款</van-radio>
              <van-radio name="0">按揭</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="hasCar"
          v-model="formValue.carPrice"
          type="digit"
          required
          clearable
          :readonly="readonly"
          label="裸车价"
          placeholder="请填写裸车价"
        />
        <van-field
          v-if="hasCar"
          readonly
          clickable
          required
          name="calendar"
          :value="formValue.carBuyTime"
          label="购买时间"
          placeholder="请选择购买时间"
          @click="showCarBuyTime = !readonly"
        />
        <van-field name="radio" label="是否有保单" required>
          <template #input>
            <van-radio-group v-model="formValue.hasPolicy" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasPolicy" name="radio" label="保单类型" required>
          <template #input>
            <van-radio-group v-model="formValue.policyType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">万能</van-radio>
              <van-radio name="1">分红</van-radio>
              <van-radio name="2">重疾</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="hasPolicy"
          v-model="formValue.policyTotalYear"
          type="digit"
          required
          clearable
          :readonly="readonly"
          label="应缴年限"
          placeholder="请填写应缴年限"
        />
        <van-field
          v-if="hasPolicy"
          v-model="formValue.policyAlreadyYear"
          type="digit"
          required
          clearable
          :readonly="readonly"
          label="实缴年限"
          placeholder="请填写实缴年限"
        />
        <van-field
          v-if="hasPolicy"
          v-model="formValue.policyEffectCount"
          type="digit"
          required
          clearable
          :readonly="readonly"
          label="保单生效期数"
          placeholder="请填写保单已生效期数"
        />
        <van-field v-if="hasPolicy" name="radio" label="缴费方式" required>
          <template #input>
            <van-radio-group v-model="formValue.policyFeeType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">月缴</van-radio>
              <van-radio name="1">季缴</van-radio>
              <van-radio name="2">年缴</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="hasPolicy"
          v-model="formValue.policyMonthFee"
          type="number"
          required
          clearable
          :readonly="readonly"
          :label="formValue.policyFeeType === '0' ? '月缴保费' : formValue.policyFeeType === '1' ? '季缴保费' : '年缴保费'"
          :placeholder="formValue.policyFeeType === '0' ? '请填写月缴保费' : formValue.policyFeeType === '1' ? '请填写季缴保费' : '请填写年缴保费'"
        />
      </van-cell-group>
    </div>
    <div class="info-container" v-if="baseConfirmed">
      <h2 class="title">征信信息</h2>
      <van-cell-group>
        <van-field name="radio" label="逾期级别" required>
          <template #input>
            <van-radio-group v-model="formValue.overdueLevel" direction="horizontal" :disabled="readonly">
              <van-radio name="0">当前逾期</van-radio>
              <van-radio name="1">关注</van-radio>
              <van-radio name="2">呆账</van-radio>
              <van-radio name="3">止付/代偿</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="法院是否执行" required>
          <template #input>
            <van-radio-group v-model="formValue.isCourtExecuted" direction="horizontal" :disabled="readonly">
              <van-radio name="0">否</van-radio>
              <van-radio name="1">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="formValue.creditCountLast1M"
          type="digit"
          clearable
          :readonly="readonly"
          label="近1月查询数"
          placeholder="请填写近1月查询数"
        />
        <van-field
          v-model="formValue.creditCountLast2M"
          type="digit"
          clearable
          :readonly="readonly"
          label="近2月查询数"
          placeholder="请填写近2月查询数"
        />
        <van-field
          v-model="formValue.creditCountLast3M"
          type="digit"
          clearable
          :readonly="readonly"
          label="近3月查询数"
          placeholder="请填写近3月查询数"
        />
        <van-field
          v-model="formValue.loanOverdueCountLast3M"
          type="digit"
          clearable
          :readonly="readonly"
          label="近3个月贷款逾期数"
          placeholder="请填写近3个月贷款逾期数"
        />
        <van-field
          v-model="formValue.loanOverdueCountLast6M"
          type="digit"
          clearable
          :readonly="readonly"
          label="近6个月贷款逾期数"
          placeholder="请填写近6个月贷款逾期数"
        />
        <van-field
          v-model="formValue.loanOverdueCountLast9M"
          type="digit"
          clearable
          :readonly="readonly"
          label="近9个月贷款逾期数"
          placeholder="请填写近9个月贷款逾期数"
        />
      </van-cell-group>
    </div>
    <ClearStorage v-if="!baseConfirmed"/>
    <van-popup v-model="showSalaryDatePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="salaryDateColumns"
        @confirm="onConfirmSalaryDate"
        @cancel="showSalaryDatePicker = false"
      />
    </van-popup>
    <van-popup v-model="showWorkCity" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="2"
        @confirm="onConfirmWorkCity"
        @cancel="showWorkCity = false"
      />
    </van-popup>
    <van-popup v-model="showHouseCity" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="2"
        @confirm="onConfirmHouseCity"
        @cancel="showHouseCity = false"
      />
    </van-popup>
    <van-calendar
      v-model="showCompanyCalendar"
      :min-date="new Date(1970, 1, 1)"
      :max-date="new Date()"
      @confirm="onConfirmCompany"
    />
    <van-calendar
      v-model="showCarBuyTime"
      :min-date="new Date(1970, 1, 1)"
      :max-date="new Date()"
      @confirm="onConfirmCarBuyTime"
    />
    <div class="button-container" v-if="baseConfirmed && status === 'wait-visit'">
      <van-button type="warning" round block @click="onSubmit" :loading="loading">
        <span>确认信息</span>
      </van-button>
    </div>
    <div class="button-container" v-if="!baseConfirmed">
      <van-button type="warning" round block @click="onSubmit" :loading="loading">
        <span>获取信息</span>
      </van-button>
    </div>
  </div>
</template>
<script>
  import ClearStorage from '@/components/ClearStorage'
  import Loading from '@/components/Loading'
  import { areaList } from '@vant/area-data'
  import * as RegExp from '@/constants/regExp'
  import { sendSmsCode, fetchBookingInfo, confirmVisit } from '@/services/OrderService'

  export default {
    components: {
      ClearStorage,
      Loading
    },
    data() {
      return {
        counting: false,
        countDown: 60,
        readonly: true,
        status: '',
        baseConfirmed: false,
        areaList,
        showWorkCity: false,
        showHouseCity: false,
        showSalaryDatePicker: false,
        showCompanyCalendar: false,
        showCarBuyTime: false,
        loading: false,
        salaryDateColumns: (function() {
          let data = []
          for (let i = 0; i < 30; i++) {
            data.push(`每月${i + 1}日`)
          }
          return data
        })(),
        formValue: {
          name: '',
          certId: '',
          phoneNo: '',
          bookingCode: '',
          workCity: '',
          employType: '',
          workCompanyType: '',
          salaryType: '',
          salaryDate: '',
          companyEstablishTime: '',
          annualTurnover: '',
          annualInvoiceAmount: '',
          annualTaxAmount: '',
          equityRatio: '',
          companyType: '',
          hasSecurityOrFunds: '',
          salaryAfterTax: '',
          securityBase: '',
          securityMonth: '',
          fundsBase: '',
          fundsMonth: '',
          fundsBalance: '',
          hasDebt: '',
          totalDebt: '',
          monthDebtRepayments: '',
          hasHouse: '',
          houseType: '',
          houseMonthMortgage: '',
          houseCity: '',
          hasCar: '',
          isCarLoan: '',
          carPrice: '',
          carBuyTime: '',
          hasPolicy: '',
          policyType: '',
          policyTotalYear: '',
          policyAlreadyYear: '',
          policyEffectCount: '',
          policyFeeType: '',
          policyMonthFee: '',
          overdueLevel: '',
          isCourtExecuted: '',
          creditCountLast1M: '',
          creditCountLast2M: '',
          creditCountLast3M: '',
          loanOverdueCountLast3M: '',
          loanOverdueCountLast6M: '',
          loanOverdueCountLast9M: ''
        }
      }
    },
    computed: {
      isEmployer() {
        return this.formValue.employType === '1'
      },
      isEmployee() {
        return this.formValue.employType === '0'
      },
      hasSecurityOrFunds() {
        return this.formValue.hasSecurityOrFunds === '1'
      },
      hasDebt() {
        return this.formValue.hasDebt === '1'
      },
      hasHouse() {
        return this.formValue.hasHouse === '1'
      },
      isHouseLoan() {
        return this.formValue.isHouseLoan === '0'
      },
      hasCar() {
        return this.formValue.hasCar === '1'
      },
      hasPolicy() {
        return this.formValue.hasPolicy === '1'
      },
      hasBottomPadding() {
        return !this.baseConfirmed || (this.baseConfirmed && this.status === 'wait-visit')
      }
    },
    methods: {
      async onSendCode() {
        if (!this.counting) {
          if (!this._validateFormValue('smsCode')) {
            return
          }
          const openId = localStorage.getItem('openId')
          const response = await sendSmsCode({
            openId,
            name: this.formValue.name,
            phoneNo: this.formValue.phoneNo,
            certId: this.formValue.certId
          })
          if (response.code === 1000) {
            this.$toast({
              message: '发送成功，请查收',
              duration: 3000
            })
          }
          this.counting = true
          clearInterval(this.sendTimer)
          this.sendTimer = setInterval(() => {
            this.countDown = this.countDown - 1
            if (this.countDown === 0) {
              clearInterval(this.sendTimer)
              this.counting = false
              this.countDown = 60
            }
          }, 1000)
        }
      },
      onConfirmSalaryDate(value) {
        this.formValue.salaryDate = value
        this.showSalaryDatePicker = false
      },
      onConfirmCompany(date) {
        const year = date.getFullYear()
        const month = this._formatMonth(date.getMonth())
        const day = date.getDate()
        this.formValue.companyEstablishTime = `${year}/${month}/${day}`
        this.showCompanyCalendar = false
      },
      onConfirmCarBuyTime(date) {
        const year = date.getFullYear()
        const month = this._formatMonth(date.getMonth())
        const day = date.getDate()
        this.formValue.carBuyTime = `${year}/${month}/${day}`
        this.showCarBuyTime = false
      },
      onConfirmWorkCity(values) {
        this.formValue.workCity = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/')
        this.showWorkCity = false
      },
      onConfirmHouseCity(values) {
        this.formValue.houseCity = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/')
        this.showHouseCity = false
      },
      async onSubmit() {
        if (!this._validateFormValue()) {
          return
        }
        const openId = localStorage.getItem('openId')
        this.loading = true
        if (!this.baseConfirmed) {
          const response = await fetchBookingInfo({
            openId,
            name: this.formValue.name,
            phoneNo: this.formValue.phoneNo,
            certId: this.formValue.certId,
            bookingCode: this.formValue.bookingCode
          })
          if (response.code === 1000) {
            this.baseConfirmed = true
            this.$toast('获取信息成功，请仔细核对信息')

            let {
              name, phoneNo, certId, bookingCode, phase, workInfo, incomeInfo, debtInfo,
              houseInfo, carInfo, policyInfo, creditInfo
            } = response.data
            workInfo = workInfo || {}
            incomeInfo = incomeInfo || {}
            debtInfo = debtInfo || {}
            houseInfo = houseInfo || {}
            carInfo = carInfo || {}
            policyInfo = policyInfo || {}
            creditInfo = creditInfo || {}
            this.status = phase
            this.formValue = {
              name,
              phoneNo,
              certId,
              bookingCode,
              ...workInfo,
              ...incomeInfo,
              ...debtInfo,
              ...houseInfo,
              ...carInfo,
              ...policyInfo,
              ...creditInfo,
              salaryDate: workInfo.salaryDate ? `每月${workInfo.salaryDate}日` : '',
              workCity: `${areaList.city_list[workInfo.workCity] || areaList.province_list[workInfo.workCity]}`,
              houseCity: `${areaList.city_list[houseInfo.houseCity] || areaList.province_list[houseInfo.houseCity]}`
            }
          }
        } else {
          const response = await confirmVisit({
            openId,
            name: this.formValue.name,
            phoneNo: this.formValue.phoneNo,
            certId: this.formValue.certId,
            bookingCode: this.formValue.bookingCode
          })
          if (response.code === 1000) {
            this.$toast('确认信息成功，请联系工作人员')
            this.status = 'visited'
          } else {
            this.$toast(response.message)
          }
        }
        this.loading = false
      },
      _formatMonth(m) {
        return (m + 1) < 10 ? `0${m}` : (m + 1)
      },
      _validateFormValue(type = 'submit') {
        const { name, certId, phoneNo, bookingCode } = this.formValue
        if (!RegExp.NAME_REG.test(name)) {
          this.$toast('请填写正确的真实姓名')
          return false
        }
        if (!RegExp.PHONE_REG.test(phoneNo)) {
          this.$toast('请填写正确的手机号码')
          return false
        }
        if (!RegExp.ID_CARD_REG.test(certId)) {
          this.$toast('请填写正确的身份证号')
          return false
        }
        if (type === 'submit') {
          if (!RegExp.CODE_REG.test(bookingCode)) {
            this.$toast('请填写正确的短信验证码')
            return false
          }
        }
        return true
      }
    }
  }
</script>
<style lang="stylus">
  .customer-info-container {
    width: 100%;
    min-height 100%
    margin: 0 auto;
    background: #f7f8fa;
    padding-bottom 84px
    .info-container {
      .title {
        padding 16px
        font-size 16px
        line-height 16px
        font-weight normal
        color rgba(69, 90, 100, 0.6)
      }
    }
    .code-field {
      padding 5px 16px
      display flex
      align-items center
    }
    .button-container {
      position: fixed
      bottom 0
      left 0
      padding: 20px 10px
      width: 100%
      background: #f7f8fa;
      .van-checkbox {
        justify-content center
        margin-bottom 5px
      }
    }
    .van-radio__icon--checked .van-icon {
      color: #fff !important
      background-color: #1989fa !important
      border-color: #1989fa !important
    }
    .van-radio__label--disabled {
      color: #323233
    }
    .van-radio__icon--disabled .van-icon {
      background-color: #fff;
      border-color: #c8c9cc;
    }
  }
</style>
